import PercentageRing from "@/pages/new-platform/components/PercentageRing";
import { useControlPanelPageData } from "../../hooks/useControlPanelPageData";
import { usePercentageRing } from "../../hooks/usePercentageRing";
import { ControlPanelCategory } from "../../types/ControlPanelCategory";
import Cardss from "./Cardss";

interface ControlPanelSectionProps {
    category: ControlPanelCategory;
}

export const ControlPanelSection = ({ category }: ControlPanelSectionProps) => {
    const { isPercentageRingVisible } = usePercentageRing()
    const { controlPanelData } = useControlPanelPageData()
    const { sectionTitle, percentage, toggleItems } = controlPanelData[category]

    return (
        <div className="space-y-[12px]">
            <div className="flex items-center justify-between gap-2.5">
                <div className={`font-bold text-[10px] ${percentage === 100 ? "text-[#3BB123]" : "text-black"}`}>{sectionTitle}</div>
                <div className={`flex-grow h-[1px] ${percentage === 100 ? "bg-[#3BB123]" : "bg-black"}`} />
                {isPercentageRingVisible && sectionTitle !== "Health Plan" && sectionTitle !== "Meal Plan" && <PercentageRing percentage={percentage} />}
            </div>
            <div className="space-y-[8px]">
                {
                    toggleItems.map((item, index) => (
                        <Cardss
                            key={index}
                            item={item}
                        />
                    ))
                }
            </div>
        </div >
    );
};
